import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPartners, createPartner, fetchPartner, modifyPartner, deletePartnerApi, changeStatus } from '../../api/partnerApi';

export const getPartners = createAsyncThunk('partner/getPartners', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchPartners(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addPartner = createAsyncThunk('partner/addPartner', async (payload, { rejectWithValue }) => {
  try {
    const response = await createPartner(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getPartnerDetails = createAsyncThunk('partner/getPartnerDetails', async (partnerId, { rejectWithValue }) => {
  try {
    const response = await fetchPartner(partnerId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updatePartner = createAsyncThunk('partner/updatePartner', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyPartner(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deletePartner = createAsyncThunk('partner/deletePartner', async (partnerId, { rejectWithValue }) => {
  try {
    const response = await deletePartnerApi(partnerId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('partner/changeDefaultStatus', async (partnerId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(partnerId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const partnerSlice = createSlice({
  name: 'partner',
  initialState: {
    partners: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPartners.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPartners.fulfilled, (state, action) => {
        state.isLoading = false;
        state.partners = action.payload;
      })
      .addCase(getPartners.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default partnerSlice.reducer;
